import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import merayemAvatar from './meryem.png';

export const SupportCard = ({ align = 'left' }: { align?: 'left' | 'center' }) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" justifyContent={align === 'left' ? 'flex-start' : 'center'}>
      <img
        src={merayemAvatar.src}
        title="client-support-avatar"
        width="70px"
        height="70px"
        alt="client-support-avatar"
      />
      <Box ml={6} textAlign="left">
        <Typography variant="caption" color="textSecondary" mb={2}>
          {t('supportCard.caption')}
        </Typography>
        <Typography variant="body1">{t('supportCard.title')}</Typography>
        <Typography variant="body2" color="textSecondary">
          {t('supportCard.subtitle')}
        </Typography>
      </Box>
    </Box>
  );
};
